import { useState, useCallback } from 'react';
import { message } from 'antd';
import api from '../services/api';

/**
 * 市场矩阵数据管理Hook
 * 负责加载市场矩阵、区间分析和品牌抢占数据
 */
export const useMarketMatrix = (skuId: string | undefined) => {
  const [matrixData, setMatrixData] = useState<any>(null);
  const [rankRangeData, setRankRangeData] = useState<any>(null);
  const [brandShiftData, setBrandShiftData] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    if (!skuId) return;
    
    try {
      setLoading(true);
      const [matrixRes, rankRangeRes, brandShiftRes] = await Promise.all([
        api.get(`/skus/${skuId}/market_matrix/`),
        api.get(`/skus/${skuId}/rank_range_analysis/`),
        api.get(`/skus/${skuId}/brand_shift_analysis/`),
      ]);
      
      setMatrixData(matrixRes.data);
      setRankRangeData(rankRangeRes.data);
      setBrandShiftData(brandShiftRes.data);
    } catch (error) {
      console.error('加载市场矩阵数据失败:', error);
      message.error('加载市场矩阵数据失败');
    } finally {
      setLoading(false);
    }
  }, [skuId]);

  return {
    matrixData,
    rankRangeData,
    brandShiftData,
    loading,
    fetchData,
  };
};

